<template>
    <div class="mainPage">
        <!-- <el-carousel :height="computeHeight"
                     :autoplay="autoplay"
                     :initial-index="initialIndex"
                     @change="onChange">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel> -->
         <img id="公司概况" class="mainImg" src="../assets/img/gsjj.png" alt="公司概况">
         <img class="mainImg" src="../assets/img/gsgk.png" alt="公司概况">
         
        <div id="服务能力" class="head-label">
            <div style="text-align: center;" class="font_size_24 f_w_bold m_tb_75">
                服务能力
            </div>
        </div>
        <div>
            <img class="mainImg" src="../assets/img/fwnl.png" alt="服务能力">
            <img class="mainImg" src="../assets/img/gdfw.png" alt="服务能力">
            <img id="合作流程" class="mainImg" src="../assets/img/hzlc.png" alt="合作流程">
            <img id="售后保障" class="mainImg" src="../assets/img/shfw.png" alt="售后保障">
            <img id="合作伙伴" class="mainImg" src="../assets/img/hzhb.png" alt="合作伙伴">
        </div>
        
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                autoplay: true, //自动播放
                initialIndex: 0, //从下标第几个开始轮播
                sliders: [],
                productSolutionsImages: [
                    {
                        img: require('../../static/other/技术咨询.png'),
                        title: "技术咨询",
                        content: ["微服务技术咨询", "物联网技术咨询"]
                    },
                    {
                        img: require('../../static/other/开发定制.png'),
                        title: "开发定制",
                        content: ["微信管理|微商城开发", "物联网平台|STM32开发"]
                    },
                    {
                        img: require('../../static/other/运维服务.png'),
                        title: "IT运维服务",
                        content: ["系统建设|日常维护", "问题处理|应急处置"]
                    },
                    {
                        img: require('../../static/other/数据分析.png'),
                        title: "数据分析",
                        content: ["交易量直观分析", "经营效果智能分析"]
                    }
                ],
                products: [
                    {
                        imgMobile: [require('../../static/other/wscsy.png'), require('../../static/other/wscfl.png'), require('../../static/other/wscgwc.png'), require('../../static/other/wscwd.png'), require('../../static/other/wscwd.png')],
                        imgAdmin: [require('../../static/other/wschdsy.png'),require('../../static/other/wschdhygl.png'), require('../../static/other/wschdspfl.png'), require('../../static/other/wschdspgl.png'), require('../../static/other/wschdddgl.png')],
                        title: "微信商城平台",
                        content: "手机端商品展示 满足多规格显示 商品直接在线购买支付"
                    }
                ],
                manages: [
                    {
                        img: [require('../../static/other/gzhzh.png'), require('../../static/other/gzhcd.png'), require('../../static/other/gzhfzgl.png'), require('../../static/other/gzhmbxx.png')],
                        title: "微信公众号管理平台",
                        content: ["支持多公众号接入", "提供公众号菜单、自动回复、公众号素材、简易CMS、等管理功能"]
                    }
                ],
                company: [
                    "企业经营范围：互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
                    "核心理念：提供软件一键式部署，实现简单可靠稳定的软件服务平台。",
                ],
            }
        },
        methods: {
            // 监听轮播图改变
            onChange(index) {
                console.log(index);
            },
            onPlayerEnded() {
                //视频播放停止时候触发的事件
                this.autoplay = true;
            },
            onPlayerPlay() {
                this.autoplay = false;
            },
        },
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/slider/swiper1.jpg")
                },
                {
                    img: require("../../static/slider/swiper2.jpg")
                },
                {
                    img: require("../../static/slider/swiper3.jpg")
                },
                {
                    img: require("../../static/slider/swiper4.jpg")
                },
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return 'calc(100vh - 65px)';
                } else {
                    return '250px';
                }
            },
            computeAdminHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '450px';
                } else {
                    return '200px';
                }
            },
            computePCHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '500px';
                } else {
                    return '200px';
                }
            },
        },
    }
</script>

<style scoped>
.mainPage{ 
    max-width: 1000px;
    margin: 0 auto;
}
    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: calc(100vh - 65px);
        width: 100%;
        object-fit:cover;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }
    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        height: 550px;
        width: 100%;
    }
    .product_admin_img {
        height: 450px;
        width: 100%;
    }
    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_pc_img {
        height: 500px;
        width: 100%
    }

    .product_pc {
        width: 90%;
        align-items: center;
        margin: 10px auto;
        background: #F2F6FC;
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 10px auto;
        background: #F2F6FC;
    }
    .font_size_24 {
        font-size: 2.5em;
    }
    .f_w_bold{ 
        font-weight: bold;
    }
    .m_tb_75{ 
        margin: 75px 0;
    }
    .mainImg{ 
        width: 100%;
        object-fit: cover;
    }
    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .mainPage{ 
            width: 100vw!important;
        }
        .font_size_24{ 
            font-size: 24px!important;
        }
        .m_tb_75{ 
            margin: 30px 0!important;
        }
        .slider_img {
            height: 250px;
            width: 100%;
        }

        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;
        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 5px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }
        .product_pc_img {
            height: 280px;
            width: 100%;
        }
        .product_pc {
            width: 90%;
            height: auto;
            margin: 20px auto;
            align-items: center;
            background: #F2F6FC;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
            justify-content: center;
            align-items: center;
        }

        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    
</style>